import { __assign } from "tslib";
import React from 'react';
import { Image, TouchableOpacity, View } from 'react-native';
import Adbuttler from '../../Adbuttler/Adbuttler';
import { getActiveFeatures } from '../../utils';
import { PnmacCard, PnmacHtmlToNative, PnmacNavigation } from 'pnmac-universal-components';
import IconArrowRightPNG from '../../assets/icon-arrow-right-20.png';
export var AdButler = function (props) {
  var layout = props.layout,
    translations = props.translations;
  return /*#__PURE__*/React.createElement(Adbuttler, __assign({
    zoneId: "600391",
    zone: " Marketing Landing Page ",
    layout: layout
  }, props, {
    FallBack: layout.offers.length > 0 && getActiveFeatures(layout.features, "View_OffersBanner", layout.whitelisted) && (/*#__PURE__*/React.createElement(TouchableOpacity, {
      onPress: function () {
        return PnmacNavigation(__assign({
          action: {
            pathname: "/Offers"
          }
        }, props));
      }
    }, /*#__PURE__*/React.createElement(PnmacCard, {
      style: {
        padding: 15,
        backgroundColor: '#003087',
        marginTop: 10,
        marginRight: 10,
        marginBottom: 20,
        marginLeft: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: translations === null || translations === void 0 ? void 0 : translations.OffersBanner
    })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Image, {
      style: {
        height: 15,
        width: 15,
        tintColor: '#fff'
      },
      source: IconArrowRightPNG
    }))))))
  }));
};